import { Link } from 'react-router-dom';
import DOMPurify from 'isomorphic-dompurify';
import React from 'react';
import Typography from '@digital-hig/mui/dist/Typography';
import Card, { CardDivider } from '@digital-hig/mui/dist/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import SvgIcon from '@mui/material/SvgIcon';
import SvgCtaArrowExternal from '@digital-hig/icon/lib/esm/icons/external';
import SvgCtaArrowInternal from '@digital-hig/icon/lib/esm/icons/cta-arrow-right';
import { ROUTER_BASENAME } from '../common/constants';
import { getEnvironmentConstant } from '../common/utilities';
import { triggerManualLinkClick } from '../common/analyticsApi';

const IndexEdCard = ({ edBlock, env, section }) => {
  const link = edBlock?.linkUrl;
  const text = edBlock?.linkText;
  const props = { onClick: () => { triggerManualLinkClick({ linkTitle: `${text}` }); } };
  const routerBasePath = getEnvironmentConstant({ key: ROUTER_BASENAME, env });
  if (link && text) {
    if (link.startsWith(routerBasePath)) { // Relative URL for Learn One - use the Link component to keep the redirect in the SPA
      props.to = link.replace(routerBasePath, '');
      props.component = Link;
    } else {
      props.href = link;
      props.target = '_blank';
    }
  }
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <CardActionArea {...props} className="cardLink">
      <Card className="cardBody">
        <CardContent className="cardContent">
          <Typography component="div" className="blockContent" color="ink-on-background" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(edBlock?.content) }} />
        </CardContent>
        <CardDivider />
        <CardActions className="cardActions">
          <Button variant="link-button" startIcon={<SvgIcon>{section === 'moreLearning' ? <SvgCtaArrowExternal /> : <SvgCtaArrowInternal />}</SvgIcon>}>
            {text}
          </Button>
        </CardActions>
      </Card>
    </CardActionArea>
  );
};

IndexEdCard.propTypes = {
  edBlock: PropTypes.shape({
    linkUrl: PropTypes.string,
    linkText: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
  env: PropTypes.string.isRequired,
  section: PropTypes.string,
};

IndexEdCard.defaultProps = {
  section: '',
};

export default IndexEdCard;
